import React from "react"
import LayoutRoot from "./src/components/layouts/LayoutRoot"

import "./src/styles/index.scss"
import 'lazysizes'

export const wrapRootElement = ({ element, props }) => {
	return <LayoutRoot {...props}>{element}</LayoutRoot>
}